// extracted by css-extract-rspack-plugin
module.exports =  {"qnawrapper":"AdD59","qnacontent":"dRNQM","qnaitem":"BBqHc","qnaanswer":"jvJps"};